module.exports = __webpack_public_path__ + "a00d2e8fc0b720ca28f47bb3eb6bd3b5.MP3";